import { useEffect } from "react";
import { Flex, Button, Form, InputNumber, Checkbox } from "antd";

import StyledModal from "./style";

import {
  cleanPercentValue,
  getPercentValue,
  selectValue,
} from "../../../../../../../../../../utils/helper/general";

const ModalSettingsFeeTaxInflation = ({
  defaultState,
  loading,
  onCancel,
  onSuccess,
  open,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) return;

    defaultState ? form.setFieldsValue(defaultState) : form.resetFields();
  }, [open]);

  return (
    <StyledModal
      closeIcon={false}
      footer={
        <Flex justify="space-between">
          <Button onClick={onCancel} shape="round">
            Cancel
          </Button>
          <Button
            disabled={loading}
            form="formFeeTaxInflation"
            htmlType="submit"
            shape="round"
            type="primary"
          >
            Update
          </Button>
        </Flex>
      }
      onCancel={onCancel}
      open={open}
      title="Edit Fees, Taxes & Inflation"
      width={501}
    >
      <Form
        id="formFeeTaxInflation"
        form={form}
        layout="vertical"
        onFinish={onSuccess}
      >
        <Flex align="center" gap={24} vertical>
          <Form.Item
            extra={
              <Form.Item name="allowOverrideAdvisorFee" valuePropName="checked">
                <Checkbox>Allow advisors to override</Checkbox>
              </Form.Item>
            }
            label="Global Advisor Fee"
            name="globalAdvisorFee"
          >
            <InputNumber
              formatter={getPercentValue}
              max={20}
              min={0}
              onClick={selectValue}
              parser={cleanPercentValue}
              precision={2}
              step={0.1}
            />
          </Form.Item>

          <Form.Item
            extra={
              <Form.Item name="allowOverrideTax" valuePropName="checked">
                <Checkbox disabled>Allow advisors to override</Checkbox>
              </Form.Item>
            }
            label="Global Tax"
            name="globalTax"
          >
            <InputNumber
              disabled
              formatter={getPercentValue}
              max={100}
              min={0}
              onClick={selectValue}
              parser={cleanPercentValue}
              precision={2}
              step={0.1}
            />
          </Form.Item>

          <Form.Item
            extra={
              <Form.Item name="allowOverrideInflation" valuePropName="checked">
                <Checkbox>Allow advisors to override</Checkbox>
              </Form.Item>
            }
            label="Global Inflation"
            name="globalInflation"
          >
            <InputNumber
              formatter={getPercentValue}
              max={100}
              min={0}
              onClick={selectValue}
              parser={cleanPercentValue}
              precision={2}
              step={0.1}
            />
          </Form.Item>
        </Flex>
      </Form>
    </StyledModal>
  );
};

export default ModalSettingsFeeTaxInflation;
